(function ($, Drupal) {
  Drupal.behaviors.list = {
    attach: function (context, settings) {

      var successHistoryItems = context.querySelectorAll('.view-view-success-story-teaser .view-content');
      if (successHistoryItems && successHistoryItems.length > 0) {
        successHistoryItems.forEach(function (element) {
          // element.classList.add('animate-on-scroll');
        });
      }

    }
  };
})(jQuery, Drupal);
